import { render, staticRenderFns } from "./BalanceManager.vue?vue&type=template&id=3ce424a0&scoped=true"
import script from "./BalanceManager.vue?vue&type=script&lang=js"
export * from "./BalanceManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce424a0",
  null
  
)

export default component.exports